import modalStyle from '../org-management-modal.module.scss';

import { Row, Col } from 'react-bootstrap';
import Input from 'components/Input';
import Button from 'components/Button';
import ModalContainer from 'components/ModalContainer';
import DropdownWithItem from 'components/DropdownWithItem';
import MessageBoxGroup from 'components/MessageBoxGroup';
import InputWithIcon from 'components/InputWithIcon';
import SpinnerForModal from "ui/SpinnerForModal";

import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

import { uiActions, selectShowModalSpinner } from "stores/slice/ui";
import usePageContext from "hooks/usePageContext";
import { organizationType } from 'const/nuclias/organization';
import { userType, userPrivilege } from 'const/nuclias/user';

import storeService from 'services/Auth.Store.service';
import storeTagService from 'services/Auth.StoreTag.service';

import useCountry from "hooks/useCountry";

import { getLocation } from "utils/googleMap.util"

import { cloneDeep, isNil, orderBy, size, startsWith } from 'lodash';
import validator from "validator";

import { defaultMessages } from "../const";
import modalController from "./modalController"

const iconStatus = {
  text: {
    type: 'text',
    className: 'icon-close-eye',
    title: '75eebe0662'

  },
  password: {
    type: 'password',
    className: 'icon-open-eye',
    title: '52a48462f8'
  }
}

const defaultModalData = {
  name: {
    value: '',
    isInvalid: false
  },
  storeTag: {},
  address: '',
  password: 'password',
  NTPServer1: 'ntp.nuclias.com',
  NTPServer2: '',
  owner: '',
  phone: '',
  email: '',
  pwStatus: 'password'
}

const OrgManagementSiteModal = ({
  info,
  modalStatus,
  handleModals,
  submitModal
}) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const showModalSpinner = useSelector(selectShowModalSpinner);
  const { getManagedSiteTagList } = usePageContext();
  const { pageContext } = useSelector((store) => store);
  const { countryList, selectedCountry, changeCountry, changeCity, setDefaultCountry } = useCountry();

  const [modalInfo, setModalInfo] = useState({});
  const [multiMessages, setMultiMessages] = useState(cloneDeep(defaultMessages));
  const [modalData, setModalData] = useState(cloneDeep(defaultModalData));
  const [tagList, setTagList] = useState([]);
  const dpRef = useRef()

  const init = async () => {
    try {
      dispatch(uiActions.showModalSpinner());
      await initModalInfo()
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(uiActions.hideModalSpinner());
    }
  }

  const initModalInfo = async () => {
    const editObj = modalStatus.site.editObj
    const tmp = {
      isCreate: modalStatus.site.type === 'create' ? true : false,
      organizationId: editObj.orgId || editObj.id
    }
    if (!info.isOrgUser) {
      if (pageContext.selectedOrg && pageContext.selectedOrg.id === tmp.organizationId) {
        tmp.targetOrg = pageContext.selectedOrg
      } else {
        const { selectedOrg } = await modalController.getSelectedOrg({ id: tmp.organizationId })
        tmp.targetOrg = selectedOrg
      }
    } else {
      tmp.targetOrg = pageContext.selectedOrg
    }

    const list = await getTagOption(tmp)
    const defData = cloneDeep(defaultModalData)
    if (tmp.isCreate) {
      defData.storeTag = list[0]
      setTagList(list)
    } else {
      const { parentTag, newTagList } = findParentTag(editObj, list)

      defData.storeTag = size(parentTag) > 0 ? parentTag[0] : list[0]
      defData.name.value = editObj.name
      defData.address = editObj.address?.address
      defData.password = editObj.storeConfig?.settings[1]?.deviceLocalPassword || ''
      defData.NTPServer1 = editObj.storeConfig?.settings[0]?.NTPServer1
      defData.NTPServer2 = editObj.storeConfig?.settings[0]?.NTPServer2
      defData.owner = editObj.owner
      defData.phone = editObj.phone
      defData.email = editObj.email

      const defCountry = {
        country: { title: editObj.address?.country || null },
        city: { title: editObj.address?.city || null }
      }
      setTagList(newTagList)
      setDefaultCountry(defCountry)
    }
    setModalInfo(tmp)
    setModalData(defData)
  }

  const getTagOption = async (tmp) => {
    let list = []
    if (info.isOrgUser)
      list = modalController.getAllTagList(getManagedSiteTagList())
    else
      if (pageContext.selectedOrg && pageContext.selectedOrg.id === tmp.organizationId)
        list = modalController.getAllTagList(tmp.targetOrg.storeTagObj)
      else
        list = modalController.getAllTagList(tmp.targetOrg.storeTagObj)
    return list
  }

  const findParentTag = (editObj, list) => {
    const parentTag = list.filter(item => item.value === editObj.parentStoreTag?.id)
    const newTagList = cloneDeep(list)
    if (size(parentTag) > 0) {
      newTagList.map(function (item) {
        item.isActive = item.value === parentTag[0].value ? true : false
        return item
      });
    }
    return { parentTag, newTagList }
  }

  const changeTag = (target) => {
    const copy = cloneDeep(tagList)
    copy.map(function (item) {
      item.isActive = item.value === target.value ? true : false
      return item
    });
    setModalData({ ...modalData, storeTag: target })
    setTagList(copy)
  }

  const toTargetCountry = (e) => {
    const key = e.key.toUpperCase()
    let targetIndex = 0;
    for (const [index, option] of countryList.country.entries()) {
      if (startsWith(option.title, key)) {
        changeCountry(option)
        targetIndex = index
        break
      }
    }
    const offsetTop = dpRef.current.children[targetIndex].offsetTop
    dpRef.current.scrollTo({ top: offsetTop });
  }

  const changeRequired = (key, value) => {
    const copy = cloneDeep(modalData)
    copy[key].value = value
    copy[key].isInvalid = checkInvalid(key, value)
    setModalData(copy)
  }

  const checkInvalid = (key, value = '') => {
    let res = true;
    const target = modalData[key]
    switch (key) {
      case 'name':
        res = validator.isLength(value, { min: 1, max: 64 })
        break;
      case 'password':
        res = validator.isLength(target, { min: 8, max: 64 })
        break;
      case 'NTPServer1':
        res = validator.isIP(target) || validator.isURL(target)
        break;
      case 'NTPServer2':
        if (size(target) > 0) res = validator.isIP(target) || validator.isURL(target)
        break;
      case 'owner':
        if (size(target) > 0) res = validator.isLength(target, { min: 1, max: 64 })
        break;
      case 'phone':
        if (size(target) > 0) res = validator.isLength(target, { min: 1, max: 32 })
        break;
      case 'email':
        if (size(target) > 0)
          res = validator.isEmail(target) && validator.isLength(target, { min: 1, max: 128 })
        break;
      default:
        res = true
    }
    return !res
  }

  const checkFormInvalid = () => {
    const checkList = [
      { key: 'name', value: true },
      { key: 'password' },
      { key: 'NTPServer1' },
      { key: 'NTPServer2' },
      { key: 'owner' },
      { key: 'phone' },
      { key: 'email' }
    ]

    let res = false
    for (const item of checkList) {
      const value = item.key ? modalData[item.key]?.value : null
      if (checkInvalid(item.key, value)) {
        res = true;
        break;
      }
    }
    return res
  }

  const formatData = () => {
    const obj = {
      name: modalData.name.value,
      address: {
        address: modalData.address,
        city: selectedCountry.city.city,
        country: selectedCountry.country.title,
        fullTimezone: selectedCountry.city.title,
        timezone: selectedCountry.city.timezone
      },
      location: {
        latitude: 0,
        longitude: 0
      },
      storeConfig: {
        NTPServer1: modalData.NTPServer1,
        NTPServer2: modalData.NTPServer2,
        NTPServer3: '',
        dayLight: selectedCountry.city.enableDST || false,
        dayLightString: selectedCountry.city.dsts || '',
        deviceLocalPassword: modalData.password
      },
      owner: modalData.owner,
      phone: modalData.phone,
      email: modalData.email,
      storeTagId: modalData.storeTag.value || null,
      organizationId: modalInfo.organizationId
    }
    const tagAction = {
      type: 'onChange',
      originId: null,
      targetId: null
    }

    if (!modalInfo.isCreate) {
      const editObj = modalStatus.site.editObj
      obj.id = editObj.id
      if ((editObj.parentStoreTag?.id || null) !== obj.storeTagId) {
        if (isNil(obj.storeTagId)) {
          tagAction.type = 'remove'
          tagAction.originId = editObj.parentStoreTag.id
        } else if (isNil(editObj.parentStoreTag.id)) {
          tagAction.type = 'add'
          tagAction.targetId = obj.storeTagId
        } else {
          tagAction.type = 'move'
          tagAction.originId = editObj.parentStoreTag.id
          tagAction.targetId = obj.storeTagId
        }
      }
    }
    return { tagAction, obj }
  }

  const submit = async () => {
    try {
      dispatch(uiActions.showModalSpinner());
      const copyMsg = cloneDeep(defaultMessages)
      const { tagAction, obj } = formatData()
      const location = await getLocation(obj.address)
      obj.location = location

      let res = null
      if (modalInfo.isCreate) {
        res = await storeService.createSite(obj)
      } else {
        let tagRes = null
        const data = { ids: [obj.id] }
        if (tagAction.type === 'add') {
          tagRes = await storeTagService.addStore(tagAction.targetId, data)
        } else if (tagAction.type === 'remove') {
          tagRes = await storeTagService.removeStore(tagAction.originId, data)
        } else if (tagAction.type === 'move') {
          data.storeTagId = tagAction.targetId
          tagRes = await storeTagService.moveStore(tagAction.originId, data)
        } else {
          // no change
        }
        if (tagRes?.error) {
          copyMsg.error = tagRes.error.code
          setMultiMessages(copyMsg)
          return
        }
        res = await storeService.updateSite(obj.id, obj)
      }

      if (res.error) {
        copyMsg.error = res.error.code
        setMultiMessages(copyMsg);
        return
      }
      const editObj = modalStatus.site.editObj
      const action = {}
      if (size(editObj.devices) > 0) action.pushResult = res.data

      submitModal(action) //targetId: obj.id,
      closeModal()
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(uiActions.hideModalSpinner());
    }
  }


  const closeModal = () => {
    setMultiMessages(cloneDeep(defaultMessages));
    handleModals({ modal: 'site', status: false })
  };

  useEffect(() => {
    init();
  }, [modalStatus.site?.status]);

  return (
    <ModalContainer
      modalWidthType='modal-500px'
      openModal={modalStatus.site.status}
      closeModal={() => closeModal()}
    >
      {showModalSpinner && <SpinnerForModal />}
      <div className='header'>
        <div className='title'>{t(modalInfo.isCreate ? 'fa111d766b' : '073ce392de')}</div>
      </div>
      <div className={`body ${modalStyle['create-site-container']}`}>
        <MessageBoxGroup
          messages={multiMessages}
          ErrorMessagesType='es'
          WarningMessagesType='i18n'
          onClose={type => setMultiMessages({ ...multiMessages, [type]: null })}
        />
        <Row>
          <Col>
            <div className='modal-form-title required'>{t('668445f09d')}</div>
            <div className='modal-form-field'>
              <Input
                placeholder={t('9fa545e2cd')}
                value={modalData.name.value}
                onChange={(e) => { changeRequired('name', e.target.value) }}
                isInvalid={modalData.name?.isInvalid}
              />
            </div>
          </Col>
          <Col>
            <div className='modal-form-title'>{t('3039a00fca')}</div>
            <div className='modal-form-field'>
              <DropdownWithItem
                id="site-tag-dropdown"
                type="normal"
                selectedItem={modalData.storeTag || {}}
                itemList={tagList}
                dropDownMenuStyle={{ maxHeight: '300px', overflow: 'auto' }}
                onClick={(item) => { changeTag(item) }}
              />
            </div>
          </Col>
        </Row>
        <Row className="d-flex align-items-end mt-1">
          <Col>
            <div className='modal-form-title required'>{t('e7d89871c4')}</div>
            <DropdownWithItem
              id="country-dropdown"
              type="normal"
              selectedItem={selectedCountry?.country || {}}
              itemList={countryList?.country || []}
              onClick={(item) => { changeCountry(item) }}
              onKeyDown={(e) => { toTargetCountry(e) }}
              dropDownMenuStyle={{ maxHeight: '300px', overflow: 'auto' }}
              dropDownMenuRef={dpRef}
              style={{ maxWidth: '218px' }}
              isTruncate
            />
          </Col>
          <Col>
            <DropdownWithItem
              id="time-zone-dropdown"
              type="normal"
              selectedItem={selectedCountry?.city || {}}
              itemList={countryList?.city || []}
              onClick={(item) => { changeCity(item) }}
              style={{ maxWidth: '218px' }}
              isTruncate
            />
          </Col>
        </Row>

        <div className={modalStyle['time-zone-hint']}>{t('8fcf451959')}</div>

        <div className='my-3'>
          <div className='modal-form-title'>{t('dd7bf230fd')}</div>
          <textarea
            value={modalData.address}
            onChange={(e) => { setModalData({ ...modalData, address: e.target.value }) }}
          />
        </div>

        <div className='my-3'>
          <div className='form-subtitle'>{t('2abec3ad4f')}</div>
          <div className={modalStyle['device-credentials-hint']}>{t('7db7c037f6')}</div>
        </div>

        <Row>
          <Col>
            <div className='modal-form-title'>{t('92f1b1481f')}</div>
            <div className='modal-form-field'>
              <div>admin</div>
            </div>
          </Col>
          <Col>
            <div className='modal-form-title required'>{t('dc647eb65e')}</div>
            <div className='modal-form-field'>
              <InputWithIcon
                type={iconStatus[modalData.pwStatus].type}
                placeholder={t('39a871a0f7')}
                autoComplete="new-password"
                value={modalData.password}
                onChange={e => { setModalData({ ...modalData, password: e.target.value }) }}
                iconTitle={iconStatus[modalData.pwStatus].title}
                iconClassName={iconStatus[modalData.pwStatus].className}
                iconOnClick={() => {
                  let newStatus = modalData.pwStatus === 'text' ? 'password' : 'text'
                  setModalData({ ...modalData, pwStatus: newStatus })
                }}
                isInvalid={checkInvalid('password')}
              />
            </div>
          </Col>
        </Row>

        <div className='form-subtitle my-2'>{t('f58b2f55c2')}</div>
        <Row>
          <Col>
            <div className='modal-form-title required'>{t('94ecb80600')}</div>
            <div className='modal-form-field'>
              <Input
                placeholder='ntp.nuclias.com'
                value={modalData.NTPServer1}
                onChange={(e) => { setModalData({ ...modalData, NTPServer1: e.target.value }) }}
                isInvalid={checkInvalid('NTPServer1')}
              />
            </div>
          </Col>
          <Col>
            <div className='modal-form-title'>{t('4a85af30a7')}</div>
            <div className='modal-form-field'>
              <Input
                value={modalData.NTPServer2}
                onChange={(e) => { setModalData({ ...modalData, NTPServer2: e.target.value }) }}
                isInvalid={checkInvalid('NTPServer2')}
              />
            </div>
          </Col>
        </Row>

        <div className='form-subtitle my-2'>{t('7b30c410c4')}</div>
        <Row>
          <Col>
            <div className='modal-form-title'>{t('49ee308734')}</div>
            <div className='modal-form-field'>
              <Input
                placeholder={t('9fa545e2cd')}
                value={modalData.owner}
                onChange={(e) => { setModalData({ ...modalData, owner: e.target.value }) }}
                isInvalid={checkInvalid('owner')}
              />
            </div>
          </Col>
          <Col>
            <div className='modal-form-title'>{t('bcc254b55c')}</div>
            <div className='modal-form-field'>
              <Input
                placeholder={t('284ac11dab')}
                value={modalData.phone}
                onChange={(e) => { setModalData({ ...modalData, phone: e.target.value }) }}
                isInvalid={checkInvalid('phone')}
              />
            </div>
          </Col>
        </Row>
        <div className='modal-form-title'>{t('b357b524e7')}</div>
        <div className='modal-form-field'>
          <Input
            placeholder={t('ca5977f4f2')}
            value={modalData.email}
            onChange={(e) => { setModalData({ ...modalData, email: e.target.value }) }}
            isInvalid={checkInvalid('email')}
          />
        </div>

      </div>
      <div className='footer'>
        <Button
          label='4a53b84974'
          className='btn-cancel'
          onClick={() => closeModal()}
        />
        <Button
          label='9639e32cab'
          className='btn-submit'
          disabled={checkFormInvalid()}
          onClick={() => { submit() }}
        />
      </div>
    </ModalContainer>
  );
};

export default OrgManagementSiteModal;
